import type { ComponentType, ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { LoadingState } from "~/components/screens/StateScreen"
import { LandingPage } from "~/routes/landing"
import OnboardingPage from "~/routes/onboarding/page"
import { api } from "~/trpc/react"
import {
	PublicSuggestionDetailPage,
	PublicSuggestionNewPage,
	PublicSuggestionsPage
} from "./public"

function CustomDomainGate({
	fallback: Fallback,
	children
}: {
	fallback: ComponentType
	children: ReactElement
}) {
	const domain = api.meta.customDomain.useQuery(undefined, { retry: false })
	const { data: board, isLoading } = api.suggestions.publicBoard.useQuery(
		{
			host: window.location.host
		},
		{ retry: false }
	)
	if (isLoading || domain.isLoading) return <LoadingState />
	if (domain.data) return <Navigate to={`/${domain.data.slug}`} replace />
	return board ? children : <Fallback />
}

export function LandingOrCustomSuggestions() {
	return (
		<CustomDomainGate fallback={LandingPage}>
			<PublicSuggestionsPage customDomain />
		</CustomDomainGate>
	)
}

export function NewOrCustomSuggestion() {
	return (
		<CustomDomainGate fallback={OnboardingPage}>
			<PublicSuggestionNewPage customDomain />
		</CustomDomainGate>
	)
}

export function CustomSuggestionDetailOrNothing() {
	return <PublicSuggestionDetailPage customDomain />
}
